export const createConsumerIcon = (name: string | undefined) => {
  if (!name || !name.trim()) {
    return 'Λ';
  }
  const trimmedName = name.trim();
  const words = trimmedName.split(/\s+/).filter((word) => word.length > 0);

  if (words.length >= 2) {
    const firstLetter = words[0][0].toUpperCase();
    const secondLetter = words[1][0].toUpperCase();
    return `${firstLetter}${secondLetter}`;
  }

  return words[0][0].toUpperCase();
};
